import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { fetchConfigurationIfNeeded } from '@lootboy/lib/actions/ConfigurationActions';
import { NOOP } from '@lootboy/lib/utils';

import { chatRadarEnabledSelector } from '~/redux/selectors';
import { useAppDispatch } from '~/redux/store/useAppDispatch';

export function useIsRadarEnabled(): boolean {
  const dispatch = useAppDispatch();
  const isRadarEnabled = useSelector(chatRadarEnabledSelector);

  useEffect(() => {
    const result = dispatch(fetchConfigurationIfNeeded());
    if (typeof result.catch === 'function') {
      result.catch(NOOP);
    }
  }, [dispatch]);

  return isRadarEnabled;
}
